import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ProviderSetting } from "../models/provider-settings";

const mockProviders: ProviderSetting[] = [
  {
    id: "cd7aa8de-e194-4569-b353-3e6e251c7084",
    name: "Liberty",
    selected: true
  },
  {
    id: "421eaae4-7630-4182-a1f2-e9249ab8ea3e",
    name: "Adelaide Bank",
    selected: true
  },
  {
    id: "e9c340fc-a17f-4618-adba-5ed3b4e62932",
    name: "ALI Group",
    selected: true
  },
  {
    id: "ffb7f26e-7a61-488b-8e51-f5b4e8fdc2a0",
    name: "AMP Financial Services",
    selected: true
  },
  {
    id: "6bd8bd02-f71b-49dd-884b-eef4a482c347",
    name: "ANZ",
    selected: true
  },
  {
    id: "bc82789d-5458-4253-98e2-be2b3015934b",
    name: "Bank Of Melbourne",
    selected: true
  },
  {
    id: "844e70eb-e8a1-433b-884f-42fc5fc7cf93",
    name: "Bank SA",
    selected: true
  },
  {
    id: "dcfc2954-9ddc-4003-9b7c-e6ada841219c",
    name: "Bankwest",
    selected: true
  },
  {
    id: "7e76c001-925a-410f-85b2-9e107f7cb788",
    name: "Commonwealth Bank of Australia",
    selected: true
  },
  {
    id: "c763bd15-3e66-409a-828a-c48c25dc2d72",
    name: "Deposit Bond Australia",
    selected: true
  },
  {
    id: "c7bdcb35-721d-40a9-8e8c-dfe64199e20f",
    name: "Health Professionals Bank",
    selected: true
  },
  {
    id: "015a703f-574d-4c29-b9f8-cdbe3e0ddea2",
    name: "Heartland",
    selected: true
  },
  {
    id: "e38c3889-2994-4530-a82d-13ab6d2694f9",
    name: "Heritage",
    selected: true
  },
  {
    id: "a3421da7-fba7-4a3f-b041-1b7271871f19",
    name: "ING Direct",
    selected: true
  },
  {
    id: "89f3d0d1-5bb1-48fd-8dc2-1ee153607cf6",
    name: "Keystart Loans",
    selected: true
  },
  {
    id: "154e92e7-d871-483f-88cb-870e06ae7d6f",
    name: "LFI Group",
    selected: true
  },
  {
    id: "03de9566-6347-42dd-821c-8e14678eedae",
    name: "Macquarie",
    selected: true
  },
  {
    id: "456547d9-f9e8-430c-b9d7-4ed1e24a5c5f",
    name: "MoneyPlace",
    selected: true
  },
  {
    id: "37acf001-7951-44f9-ac0d-467a9d35e572",
    name: "Moula",
    selected: true
  },
  {
    id: "ca3ee4d2-9db5-431f-9115-45584969e03d",
    name: "My State",
    selected: true
  },
  {
    id: "f1933a35-8b4f-46ff-85fe-3922504bc751",
    name: "National Australia Bank",
    selected: true
  },
  {
    id: "7cdff2a8-c88c-405f-a4d6-5433d46c46b4",
    name: "COG",
    selected: true
  },
  {
    id: "487ca887-e034-423b-8c16-db4bd2910fe5",
    name: "ScotPac",
    selected: true
  },
  {
    id: "27cfaaed-fc8d-405e-bc4b-4f21939d0f40",
    name: "St George bank",
    selected: true
  },
  {
    id: "45334f0d-5a36-4798-a247-3656f1c3a77d",
    name: "Suncorp Bank",
    selected: true
  },
  {
    id: "c1428f92-22ee-4db1-a7bb-69259b924f8c",
    name: "Teachers Mutual Bank",
    selected: true
  },
  {
    id: "cc867f3a-faf2-467c-ab3e-8b3cad24cbe2",
    name: "UniBank",
    selected: true
  },
  {
    id: "16f515e2-08f8-46b0-bbb0-99bba9bfbc63",
    name: "Westpac Bank",
    selected: true
  }
];

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  getProviders(): Observable<ProviderSetting[]> {
    return of(mockProviders);
  }
  updateProviders(providers: ProviderSetting[]): Observable<ProviderSetting[]> {
    return of(providers);
  }
}